import Fb from '../images/facebook.png';
import Insta from '../images/instagram.png';
import Twitter from '../images/twitter.png';
import Lin from '../images/linkedin-logo.png';
import github from '../images/github-logo.png';

export default function Footer(){
    return (
        <>
                <div class="container">
          <h2 class="display-5">Find me here</h2>
          <hr class="my-4"/>
          <ul class="social">
            <li><a href="https://facebook.com/yash.thaker.7" target="_blank" rel="noopener noreferrer"><img src={Fb}alt=""  width="32px" height="32px"/></a></li>
            <li><a href="https://instagram.com/october7sveryown" target="_blank" rel="noopener noreferrer"><img src={Insta} alt=""  width="32px" height="32px"/></a></li>
            <li><a href="https://twitter.com/itsYash777" target="_blank" rel="noopener noreferrer"><img src={Twitter} alt=""  width="32px" height="32px"/></a></li>
            <li><a href="https://linkedin.com/in/yash-thaker" target="_blank"rel="noopener noreferrer"><img src={Lin}alt=""  width="32px" height="32px"/></a></li>
            <li><a href="https://github.com/october7sveryown" target="_blank"rel="noopener noreferrer"><img src={github}alt=""  width="32px" height="32px"/></a></li>
          </ul>
        </div>
        <br/>
        <br/>
        
        <div class="credits">
          <p class="lead text-center white-text">Made with <span style={{color:'red'}}>&hearts;</span> by me, ofcourse</p>
        </div>
        </>
    )
}